import { render, staticRenderFns } from "./ProcedureSort.vue?vue&type=template&id=049961da&scoped=true&"
import script from "./ProcedureSort.vue?vue&type=script&lang=js&"
export * from "./ProcedureSort.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureSort.vue?vue&type=style&index=0&id=049961da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049961da",
  null
  
)

export default component.exports